import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';

import { parseDateField } from '../../../utils';

type ContractReply = AdvertiserAccount.User.UsersReply;

export const user = (data: ContractReply['users'][number]) => {
  parseDateField(data.permission, 'created_at');

  return data;
};
// export type User = ReturnType<typeof user>;
